import { render } from "./fotter.vue?vue&type=template&id=28b8fb8b&scoped=true"
import script from "./fotter.vue?vue&type=script&lang=js"
export * from "./fotter.vue?vue&type=script&lang=js"

import "./fotter.vue?vue&type=style&index=0&id=28b8fb8b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b8fb8b"]])

export default __exports__